var _excluded = ["expanded"],
    _excluded2 = ["title", "titleComponent", "subtitle", "icon", "children", "borderBottom", "hideItemBorder", "expanded", "onToggleExpanded", "onExpand", "onCollapse", "onBeforeExpand", "onBeforeCollapse", "triggerId", "contentPadding"];

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

import React from "react";
import slugify from "slugify";
import styled from "styled-components";
import Expander from "@nib-components/expander";
import Heading from "@nib-components/heading";
import { copyFontSizeSmall, validSpacingValues, focusOutlineColor, focusOutlineStyle, focusOutlineWidth, focusOutlineOffset, copyFontFamily } from "@nib-components/theme";
import { ChevronDownSystemIcon } from "@nib/icons";
import { Columns, Column, p, m } from "@nib/layout";
import { BORDER_VALUE } from "./utils";
var Item = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", ";\n\n  ", ";\n"])), function (_ref) {
  var hideItemBorder = _ref.hideItemBorder;
  return !hideItemBorder && "\n    border-bottom: ".concat(BORDER_VALUE, ";\n  ");
}, function (_ref2) {
  var borderBottom = _ref2.borderBottom;
  return !borderBottom && "\n    &:last-child {\n      border-bottom: none;\n    }\n  ";
});
Item.displayName = "Item";
var Trigger = styled.button(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n  -webkit-tap-highlight-color: transparent;\n  -webkit-appearance: none;\n  border: none;\n  background: transparent;\n  color: inherit;\n  display: block;\n  width: 100%;\n  text-align: inherit;\n\n  ", ";\n  cursor: pointer;\n\n  &:disabled {\n    cursor: default;\n    pointer-events: none;\n  }\n\n  &:focus {\n    outline: ", " ", " ", ";\n    outline-offset: ", ";\n  }\n"])), p(4), focusOutlineWidth, focusOutlineStyle, focusOutlineColor, focusOutlineOffset);
Trigger.displayName = "Trigger";
/**
* The default heading 4 size varies wildly across brands.
* There is debate around adopting a standard typescale for all brands,
* so in the meantime we are standardising just this accordion title size.
*/

var Title = styled(Heading)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  font-size: 1.25rem;\n"])));
Title.displayName = "Title";
var Subtitle = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: ", ";\n  ", ";\n"])), copyFontFamily, copyFontSizeSmall, m(0));
Subtitle.displayName = "Subtitle";
var Chevron = styled(function (_ref3) {
  var expanded = _ref3.expanded,
      otherProps = _objectWithoutProperties(_ref3, _excluded);

  return /*#__PURE__*/React.createElement(ChevronDownSystemIcon, otherProps);
})(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  ", ";\n  transition: transform 300ms cubic-bezier(0.55, 0.085, 0.68, 0.53);\n"])), function (_ref4) {
  var expanded = _ref4.expanded;
  return expanded && "transform: rotate(180deg);";
});
Chevron.displayName = "Chevron";
var Content = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  ", ";\n  font-family: ", ";\n\n  /* MAGIC: Animations don't account for the full height of an element with a margin-bottom causing a jerk at the end of the animation */\n  /* This override fixes that. */\n  & > :last-child {\n    margin-bottom: 0 !important;\n  }\n\n  & > :first-child {\n    margin-top: 0 !important;\n  }\n"])), function (props) {
  return p(typeof props.contentPadding === "number" ? props.contentPadding : 4);
}, copyFontFamily);
Content.displayName = "Content";

var AccordionItem = function AccordionItem(props) {
  var title = props.title,
      titleComponent = props.titleComponent,
      subtitle = props.subtitle,
      Icon = props.icon,
      children = props.children,
      borderBottom = props.borderBottom,
      hideItemBorder = props.hideItemBorder,
      _props$expanded = props.expanded,
      expanded = _props$expanded === void 0 ? false : _props$expanded,
      onToggleExpanded = props.onToggleExpanded,
      onExpand = props.onExpand,
      onCollapse = props.onCollapse,
      onBeforeExpand = props.onBeforeExpand,
      onBeforeCollapse = props.onBeforeCollapse,
      triggerId = props.triggerId,
      contentPadding = props.contentPadding,
      otherProps = _objectWithoutProperties(props, _excluded2);

  return /*#__PURE__*/React.createElement(Item, _extends({}, otherProps, {
    borderBottom: borderBottom,
    hideItemBorder: hideItemBorder
  }), /*#__PURE__*/React.createElement(Trigger, {
    onClick: onToggleExpanded,
    "aria-expanded": expanded,
    id: triggerId || slugify("ga-inlink-".concat(title), {
      lower: true
    }),
    type: "button"
  }, /*#__PURE__*/React.createElement(Columns, {
    verticalAlign: "center",
    space: 3
  }, Icon && /*#__PURE__*/React.createElement(Column, {
    width: "content"
  }, /*#__PURE__*/React.createElement(Icon, {
    size: "sm"
  })), /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Title, {
    size: 4,
    component: titleComponent
  }, title), subtitle && /*#__PURE__*/React.createElement(Subtitle, null, subtitle)), /*#__PURE__*/React.createElement(Column, {
    width: "content"
  }, /*#__PURE__*/React.createElement(Chevron, {
    size: "xs",
    expanded: expanded
  })))), /*#__PURE__*/React.createElement(Expander, {
    expanded: expanded,
    onExpand: onExpand,
    onCollapse: onCollapse,
    onBeforeExpand: onBeforeExpand,
    onBeforeCollapse: onBeforeCollapse
  }, /*#__PURE__*/React.createElement(Content, {
    contentPadding: contentPadding,
    role: "region"
  }, children)));
};

AccordionItem.displayName = "Accordion.Item";
export default AccordionItem;